import type { ActKc3TotalData } from 'gql/graphql';

import type { ICellRendererParams } from 'ag-grid-community';

interface TCostCellRenderer extends ICellRendererParams<ActKc3TotalData> {
    hideHeadLineValue: boolean;
}

export const CostCell = (props: TCostCellRenderer) => {
    const { data, hideHeadLineValue, valueFormatted } = props;

    if (hideHeadLineValue && data?.isHeadLine) {
        return '';
    }

    return valueFormatted;
};

CostCell.displayName = 'CostCell';
